import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { ApiError } from '@/api/client.ts';
import { useGetMe } from '@/api/generated/users.ts';
import { useListWorkspaces } from '@/api/generated/workspaces.ts';
import { UnexpectedErrorActionContext } from '@/core/components/ErrorMessage.tsx';
import { setLanguage } from '@/core/i18n/index.ts';
import { ReportProblemButton } from '@/support/ReportProblemDialog.tsx';

// The app's pages need a signed-in user; otherwise sign-in. Signed in, an unexpected error can be reported (plan task 98).
const RequireSession = () => {
    const location = useLocation();
    const user = useGetMe();
    // Asked alongside the user instead of after it: a workspace's pages wait for both (AppLayout), and on a slow
    // connection each request in a row adds its round trip to the first load.
    useListWorkspaces();
    const language = user.data?.language;

    // The language saved on the account, e.g. after signing in on another browser.
    useEffect(() => {
        if (language) setLanguage(language);
    }, [language]);

    if (user.error instanceof ApiError && user.error.status === 401) {
        return <Navigate to={`/sign-in?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
    }
    if (user.error) throw user.error;
    if (!user.data) return null;
    return (
        <UnexpectedErrorActionContext value={<ReportProblemButton />}>
            <Outlet />
        </UnexpectedErrorActionContext>
    );
};

export default RequireSession;
